/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type contactDealerAuthHandler_viewer$ref = any;
export type contactDealerAuthHandler_viewer = {
    readonly disableEmailOnlyRegistration: boolean | null;
    readonly disableEmailOnlyMc: boolean | null;
    readonly " $refType": contactDealerAuthHandler_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "contactDealerAuthHandler_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "disableEmailOnlyRegistration",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "DISABLE_EMAIL_ONLY_REGISTRATION"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_EMAIL_ONLY_REGISTRATION\")"
        },
        {
            "kind": "ScalarField",
            "alias": "disableEmailOnlyMc",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "DISABLE_EMAIL_ONLY_MC"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_EMAIL_ONLY_MC\")"
        }
    ]
} as any);
(node as any).hash = '5a66224a376a2dc053e8103c4df957a5';
export default node;
